import {ImageLayer} from '../ImageLayer.js';
import Library from '../Library.js';

export class WeatherLayer extends ImageLayer {

    constructor( map, settings = {} ){
        settings["name"] = 'weather';
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        settings["api_endpt"] = "model.php";
        if( settings.opacity == undefined ) settings['opacity'] = 0.75;
        if( settings.type == undefined ) settings['type'] = "rap_temp";
        if( settings.model == undefined ) settings['model'] = "rap";
        if( settings.level == undefined ) settings['level'] = "sfc";
        if( settings.param == undefined ) settings['param'] = "temp";
        super( map, settings );
        this.setLabel();
    }

    getExtent( model ){
        if( model == 'rap')
            return [ -14990770, 2139913, -6827850, 8032833 ];
        return [ -14990770, 2139913, -6827850, 8032833 ];
    }

    getUrl(){
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "model", this.settings['model'] );
        if( this.settings['level'] == undefined )
            url.searchParams.set( "level", this.map.level );
        else
            url.searchParams.set( "level", this.settings['level'] );
        url.searchParams.set( "param", this.settings['param'] );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    refresh(){
        console.info( 'weather refresh');
        this.updateSource();
        super.refresh();
        this.setLabel();
    }

    setLevel(val){
        console.info('weather new level', val);
        this.updateSource();
    }

    setVisible(val){
        super.setVisible(val);
        this.setLabel();
    }

    async setLabel(){
        if( !this.layer.isVisible() ) return;
        let elem = document.getElementById('label_weather');
        if( elem == null ) return;
        if( this.settings['model'] == "none" ){
            elem.innerText = "";
            return;
        }
        console.info( "weather set label");
        let url = new URL( this.map.server + "/cgi-bin/image/model.php" );
        url.searchParams.set( "model", this.settings['model'] );
        if( this.settings['level'] == undefined )
            url.searchParams.set( "level", this.map.level );
        else
            url.searchParams.set( "level", this.settings['level'] );
        url.searchParams.set( "param", this.settings['param'] );
        url.searchParams.set( "output", "label" );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        let response = await fetch( url.toString());
        let label = await response.text();
        elem.innerText = label;
        console.info( 'weather label', label );
    }

    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        this.layer.setOpacity( this.settings['opacity'] );
        return 1;
    }
    
    setType( type ){
        if( type == "none" ){
            this.settings['model'] = "none";
        }
        let fields = type.split("_");
        if( fields.length == 3 ){
            this.settings['model'] = fields[0];
            this.settings['level'] = fields[1];
            this.settings['param'] = fields[2];
        } else if( fields.length == 2 ){
            this.settings['model'] = fields[0];
            this.settings['level'] = undefined;
            this.settings['param'] = fields[1];
        } else {
            this.settings['param'] = fields[0];
        }
        this.updateSource();
        this.setLabel();

    }

    updateLevel(){
        this.refresh();
    }

    updateTime(){
        this.refresh();
    }
}